import { store } from '@betacrew/jars-flux'

export const componentKey = "BOI/BENEFICIARY_OWNER";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFormFields: (state, action) => {
            state.formFields = action.payload;
        },
        setIsBenefiarySubmitSuccess: (state, action) => {
            state.isBenefiarySubmitSuccess = action.payload;
        },
        setBeneficiaryDetailId: (state, action) => {
            state.beneficiaryDetailId = action.payload;
        },
        setFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = action.payload;
        },
        updateFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = {
                ...state.formsPreLoadedData,
                ...action.payload,
            }
        },
        setIsErrorOccurred: (state, action) => {
            state.isErrorOccurred = action.payload;
        },
        setShowHelpPopup: (state, action) => {
            state.showHelpPopup = action.payload;
        },
        setHelpTextObj: (state, action) => {
            state.helpTextObj = action.payload;
        },
        updateHelpTextObj: (state, action) => {
            state.helpTextObj = {
                ...state.helpTextObj,
                ...action.payload,
            };
        },

    },
    initialReducerState: {
        loadingState: false,
        formFields: [],
        isBenefiarySubmitSuccess: null,
        beneficiaryDetailId: 0,
        formsPreLoadedData: {},
        isErrorOccurred: false,
        showHelpPopup: false,
        helpTextObj: {},
    }
});

export const { setLoadingState, setFormFields, setIsBenefiarySubmitSuccess, setBeneficiaryDetailId, setFormsPreLoadedData, updateFormsPreLoadedData, setIsErrorOccurred, setShowHelpPopup, setHelpTextObj, updateHelpTextObj } = actions;